<template>
	<div class="page">
		<HeaderBar title="自身抗体"></HeaderBar>
		<div class="center-box-no-footer">
			<van-form :model="form" ref="form">
				<van-cell-group v-show="form.bq400zskt.guid">
					<FormNormalInput label="异常" v-model="form.bq400zskt.bq400115" readonly />
					<FormNormalInput v-show="form.bq400zskt.bq400115=='有'" label="异常描述"
						v-model="form.bq400zskt.bq4001152" readonly />
				</van-cell-group>
				<!-- <FormNormalUpload label="上传报告" ref="normalUpload" :infoGuid='form.bq400zskt.guid'></FormNormalUpload> -->
				<!--        <div class="page-bottom-box" style="margin: 16px;">
          <van-button block type="info" @click="SaveInfo">保存</van-button>
        </div> -->
			</van-form>
		</div>
	</div>
</template>
<script>
	// 引入服务组件
	import componentsModel from '../../../base/components.js'
	// 引入子页面的混入对象
	import mixinModel from '../mixins/mixins.js'
	export default {
		name: "page008",
		mixins: [mixinModel],
		data() {
			return {
				modelname: 'bq400zskt',
				form: {
					bq400zskt: {
						id: "0", //编号
						guid: "", //guid编号
						companyGuid: "", //单位编号
						departmentGuid: "", //部门编号
						checkStatus: "", //审核状态
						dataStatus: "", //数据状态
						addUid: "", //添加人编号
						addTime: "", //添加时间
						bq400guid: "", //随访基本信息表编号
						bq400115: "无", //异常0-没有，1-有
						bq4001152: "", //异常描述
						Bq400_guid: '', //随访基本信息表编号
						Bq400_115: '', //异常0-没有，1-有
						Bq400_115_2: '', //异常描述
					},
					sempFiles: []
				},
				fullscreenLoading: false,
				//保存接口
				saveUrl: this.$utils.Url.s400 + '/api/S400Bq400zskt/Save',
				bq400: JSON.parse(sessionStorage.getItem('bq400'))
			}
		},
		components: {
			...componentsModel
		},
		methods: {
			//保存按钮成功回调事件
			saveSucess: function() {
				//调用列表页的closeDialog方法
				// this.Back()
			},
			//加载信息
			LoadInfo: function() {
				var that = this
				var args = {
					bq400guid: this.bq400.guid
				}
				that.$utils.HttpPost(this.$utils.Url.s400 + '/api/S400Bq400zskt/Info', args, function(d) {
					let dataModel = d.Data
					that.$utils.CopyKeyInfo(dataModel, dataModel)
					that.$utils.CopyPro(dataModel, that.form.bq400zskt)
				}, null, null, null);
			},

			//保存信息
			SaveInfo: function() {
				let that = this
				that.$utils.CopyKeySave(that.form.bq400zskt, that.form.bq400zskt)
				that.form.sempFiles = that.$refs.normalUpload.GetFileList()
				that.$refs.btnSave.Save()
			},
		},
		mounted() {
			this.form.bq400zskt.bq400guid = this.bq400.guid
			this.LoadInfo()
		}
	}
</script>

<style scoped>

</style>
